import Swiper from 'swiper';
import { createSwiper } from '../utils/swiper';

export const initLogosSlider = ( el: HTMLElement ) => {
	const Object = {
		config: {
			maxSlidesPerView: 5,
		},
		container: el,
		slides: el.querySelectorAll( '.wv-logo-slide' ) as NodeListOf<HTMLElement>,
		swiper: null as Swiper | null,

		_init(): void {
			console.log( 'Init Logos Slider: ', this.container, this.slides );

			this.setupLogosSlider();
		},

		setupLogosSlider(): void {
			const hasEnoughSlides: boolean = this.slides.length > this.config.maxSlidesPerView;

			this.swiper = createSwiper( this.container, 'wv-logo-slide', {
				autoplay: {
					delay: 1000,
					disableOnInteraction: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 2,
						spaceBetween: 8,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 5,
						spaceBetween: 20,
					},
				},
				centeredSlides: false,
				direction: 'horizontal',
				loop: hasEnoughSlides,
				mousewheel: true,
			} );
		},
	};

	Object._init();
	return Object;
};

export const initLogosSliders = ( selectors = '.wv-logos-slider' ): void => {
	const blocks = document.querySelectorAll( selectors ) as NodeListOf<HTMLElement>;

	blocks.forEach(
		( el: HTMLElement ) => initLogosSlider( el )
	);
};
